import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2f484912&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=2f484912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f484912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f484912')) {
      api.createRecord('2f484912', component.options)
    } else {
      api.reload('2f484912', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2f484912&scoped=true&", function () {
      api.rerender('2f484912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/addMergeForm/list.vue"
export default component.exports